'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/core-js/object/define-property');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineEnumerableProperties2 = require('babel-runtime/helpers/defineEnumerableProperties');

var _defineEnumerableProperties3 = _interopRequireDefault(_defineEnumerableProperties2);

var _defineProperty4 = require('babel-runtime/helpers/defineProperty');

var _defineProperty5 = _interopRequireDefault(_defineProperty4);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _class2, _temp;

var _mobx = require('mobx');

var _simgateInputStore = require('simgate-input-store');

var _simgateInputStore2 = _interopRequireDefault(_simgateInputStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty3.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var DataModel = (_dec = _mobx.observable.shallow, _dec2 = _mobx.observable.shallow, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, (_class = (_temp = _class2 = function (_SimgateInputStore) {
  (0, _inherits3.default)(DataModel, _SimgateInputStore);

  function DataModel() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, DataModel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DataModel.__proto__ || (0, _getPrototypeOf2.default)(DataModel)).apply(this, arguments));

    _this.wait = null;
    _this.loadDebounceTime = 500;
    _this.globalMode = true;

    _initDefineProp(_this, 'loadWasRequested', _descriptor, _this);

    _initDefineProp(_this, 'loadWasSuccess', _descriptor2, _this);

    _initDefineProp(_this, 'loadWasFailure', _descriptor3, _this);

    _initDefineProp(_this, 'domainStore', _descriptor4, _this);

    _initDefineProp(_this, 'stores', _descriptor5, _this);

    _initDefineProp(_this, 'queuedStores', _descriptor6, _this);

    _initDefineProp(_this, '_pathId', _descriptor7, _this);

    var stores = opts.stores,
        pathId = opts.pathId;

    // grab the init stores

    if (pathId) _this._pathId = opts.pathId;

    stores && stores.forEach(function (s) {
      return _this.addStore(s);
    });

    // set up loading listener, debounce
    (0, _mobx.reaction)(function () {
      return _this.loadWasRequested;
    }, function () {
      return _this.loadData();
    }, {
      delay: _this.loadDebounceTime || 0,
      fireImmediately: true
    });

    return _this;
  } // a mobx "when" gets attached if path not ready
  // in ms
  // global indirection / loading mode

  // loading hooks
  // optional, referenced for pathId if exists
  // stores registered
  // currently queued stores (for loading)

  (0, _createClass3.default)(DataModel, [{
    key: 'isStoreQueued',

    // pending mobx fix
    // set pathId(val){
    //   debugger
    //   this._pathId = val;
    // }

    value: function isStoreQueued(store) {
      return this.queuedStores.some(function (i) {
        return i === store;
      });
    }
  }, {
    key: 'addStore',
    value: function addStore(Store) {
      var _this2 = this;

      var extensions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (extensions.id && this[extensions.id]) {
        if (!this[extensions.id].isLoaded) this[extensions.id].loadData();
        console.log("returning existing store: " + extensions.id);
        return this[extensions.id];
      }

      if (!Store.prototype) throw new Error("store already initialiazed, or incorrect type");

      var AdaptedStore = this.adaptInputStore(Store);

      var store = new AdaptedStore((0, _assign2.default)({ simgate: this.simgate }, extensions));

      var id = store.id;
      if (this[id]) {
        if (!this[id].isLoaded) this[id].loadData();
        console.log("returning existing store: " + id);
        return this[id];
      }

      store.loadableVariableNames.forEach(function (k) {
        return _this2.addKey(k, store);
      });

      //add to dataModel
      this[id] = store;
      this.stores.push(store);

      if (!store.isLoaded) {
        (0, _mobx.when)(function () {
          return _this2.pathId;
        }, function () {
          return store.loadData();
        });
      }

      return store;
    }
  }, {
    key: 'addKey',
    value: function addKey(key, store) {
      var _store$extendData, _mutatorMap;

      var globalStore = this;
      if (!this.inputs.hasOwnProperty(key)) {
        this.extendData(this.inputs, (0, _defineProperty5.default)({}, key, store.inputs[key] || null));
      }

      // dereference to global store
      if (store.inputs.$mobx && store.inputs.$mobx.values.hasOwnProperty(key)) {
        delete store.inputs.$mobx.values[key];
        delete store.inputs.$mobx.target[key];
        delete store.inputs[key];
      }

      store.extendData(store.inputs, (_store$extendData = {}, _mutatorMap = {}, _mutatorMap[key] = _mutatorMap[key] || {}, _mutatorMap[key].get = function () {
        return globalStore.inputs[key];
      }, _mutatorMap[key] = _mutatorMap[key] || {}, _mutatorMap[key].set = function (val) {
        globalStore.inputs[key] = val;
      }, (0, _defineEnumerableProperties3.default)(_store$extendData, _mutatorMap), _store$extendData));
    }
  }, {
    key: 'adaptInputStore',
    value: function adaptInputStore(Store) {
      var _dec9, _desc2, _value2, _class3, _class4, _temp2;

      if (this.globalMode === false) return Store;
      var self = this;
      var id = Store.id || Store.name;

      return _dec9 = _mobx.action.bound, (_class3 = (_temp2 = _class4 = function (_Store) {
        (0, _inherits3.default)(_class3, _Store);

        function _class3() {
          (0, _classCallCheck3.default)(this, _class3);

          var _this3 = (0, _possibleConstructorReturn3.default)(this, (_class3.__proto__ || (0, _getPrototypeOf2.default)(_class3)).apply(this, arguments));

          _this3.$parent = self;

          delete _this3.constructor.name;
          Object.defineProperty(_this3.constructor, "name", {
            enumerable: true,
            value: "AdaptedByDataModel_" + id
          });
          return _this3;
        }

        (0, _createClass3.default)(_class3, [{
          key: 'loadData',
          value: function loadData(cb, errCb, forceRetry) {
            var _this4 = this,
                _arguments = arguments;

            // in this context, this === store
            if (this.isLoading) {
              // force reload
              if (forceRetry) (0, _mobx.when)(function () {
                return _this4.isLoaded;
              }, function () {
                return _this4.loadData.apply(_this4, _arguments);
              });
              return console.warn("already loading...");
            }

            this.dataWillLoad = +new Date();

            // we'll want to clear data to make way for the new, but only if we've
            // already saved once (dont want to wipe defaults)
            if (this.dataWasSaved) {
              this.clearData();
            }

            // make an official load request
            this.$parent.requestLoad(this);

            var cachedDataWillLoad = this.$parent.dataWillLoad;

            (0, _mobx.when)(
            //next iteration that data will load
            function () {
              return _this4.$parent.dataWillLoad > cachedDataWillLoad;
            }, function () {
              // listening for dataModel loadWasSuccess
              var rxn1 = (0, _mobx.reaction)(function () {
                return _this4.$parent.loadWasSuccess;
              }, function () {
                _this4.dataWasLoaded = +new Date();
                cb && cb();
                rxn1();
                rxn2();
              });

              // listening for dataModel loadWasFailure
              var rxn2 = (0, _mobx.reaction)(function () {
                return _this4.$parent.loadWasFailure;
              }, function () {
                errCb && errCb(_this4.$parent.loadWasFailure.error);
                rxn1();
                rxn2();
              });
            });
          }
        }]);
        return _class3;
      }(Store), _class4.id = id, _temp2), (_applyDecoratedDescriptor(_class3.prototype, 'loadData', [_dec9], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'loadData'), _class3.prototype)), _class3);
    }
  }, {
    key: 'requestLoad',
    value: function requestLoad(store) {
      // add to queued stores in datamodel
      if (!this.isStoreQueued(store)) {
        this.queuedStores.push(store);
      }

      // officially request load
      this.loadWasRequested = +new Date();
    }
  }, {
    key: 'saveData',
    value: function saveData() {
      console.warn("dont do this! save data by store individually");
    }
  }, {
    key: 'loadData',
    value: function loadData(onSuccess, onFail) {
      var _this5 = this;

      if (!this.pathId || this.isLoading) {
        !this.pathId && console.log("waiting for pathId...");
        this.isLoading && console.log("waiting for loading to stop...");
        return this.wait || (this.wait = (0, _mobx.when)(function () {
          return _this5.pathId && !_this5.isLoading;
        }, function () {
          delete _this5.wait;
          _this5.loadData();
        }));
      }
      console.log("loading datamodel:", this.queuedStores.map(function (k) {
        return k.id;
      }).join(", "));

      this.dataWillLoad = +new Date();

      // make a local clone 
      var queuedStores = this.queuedStores.slice();

      // clear queue now that we're kicking this off!
      this.queuedStores.clear();

      // get all variable names for the stores we will load
      var allVarNames = queuedStores.reduce(function (accumulator, store) {
        accumulator.unshift.apply(accumulator, (0, _toConsumableArray3.default)(store.loadableVariableNames));
        return accumulator;
      }, []);

      if (!allVarNames.length) {
        console.log("nothing to load");
        return setTimeout((0, _mobx.action)("nothingToLoad", function () {
          _this5.loadWasSuccess = _this5.dataWasLoaded = +new Date();
        }), 10);
      }

      var taskArgs = [this.simgate.selectData, {
        select: allVarNames,
        path: this.pathId
      }, {
        //wrap in action for mobx transaction purposes (only refresh views after complete)
        onSuccess: (0, _mobx.action)("loadData-callback", function (res) {

          // @TODO still works this way after fix?
          _this5.setState((0, _values2.default)(res.selected), (0, _keys2.default)(res.selected));

          queuedStores.forEach(function (store) {
            return store.updateCache && store.updateCache();
          });
          _this5.loadWasSuccess = _this5.dataWasLoaded = +new Date();

          if (typeof onSuccess === "function") {
            onSuccess(res);
          }
          if (typeof _this5.onSuccess === "function") {
            _this5.onSuccess(res);
          }
        }),
        onFailure: (0, _mobx.action)("loadData-error", function (err) {
          _this5.loadWasFailure = {
            time: +new Date(),
            error: err
          };

          if (typeof onFail === "function") {
            onFail(err);
          }
          if (typeof _this5.onFail === "function") {
            _this5.onFail(err);
          }
        })
      }];

      if (this.simgate.runTask) {
        var _simgate;

        (_simgate = this.simgate).runTask.apply(_simgate, taskArgs);
      } else if (this.simgate.AsyncTask) {
        var asyncTask = new this.simgate.AsyncTask();
        asyncTask.runTask.apply(asyncTask, taskArgs);
      } else {
        this.simgate.selectData(taskArgs[1]).then(taskArgs[2].onSuccess).catch(taskArgs[2].onFailure);
      }
    }
  }, {
    key: 'pathId',
    // manual pathId override
    get: function get() {
      return this._pathId || this.domainStore && this.domainStore.context.pathID;
    }
  }]);
  return DataModel;
}(_simgateInputStore2.default), _class2.id = "dataModel", _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'loadWasRequested', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'loadWasSuccess', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'loadWasFailure', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      time: 0,
      error: null
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'domainStore', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'stores', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'queuedStores', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, '_pathId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'pathId', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'pathId'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addStore', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addStore'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addKey', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addKey'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'adaptInputStore', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'adaptInputStore'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'requestLoad', [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'requestLoad'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'saveData', [_dec7], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'saveData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadData', [_dec8], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadData'), _class.prototype)), _class));
exports.default = DataModel;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DataModel, 'DataModel', 'src/core_modules/simgate-datamodel/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/simgate-datamodel/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/simgate-datamodel/index.js
// module chunks = 0